import { Link } from "react-router-dom";
import FlipbookViewer from "../components/FlipbookViewer";

export default function AboveGroundPools() {
  return (
    <div>
      {/* Hero */}
      <section className="relative bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <h1 className="text-3xl md:text-5xl font-bold text-white">ABOVE GROUND POOL</h1>
        </div>
      </section>

      {/* Installation Process */}
      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <div className="text-center mb-10">
            <h2 className="text-xl md:text-3xl font-bold text-gray-900">Our Above Ground Pool Installation Process</h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
            {/* Left - Text */}
            <div>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-4">
                At ATLAS PRO SERVICES LLC, we begin every project with a personalized on-site consultation. This allows us to meet with you, understand your vision for pool placement, and address any questions you may have. During this visit, we'll present a range of pool sizes and equipment packages, customized to suit your unique needs and preferences.
              </p>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-4">
                We take the time to guide you through the entire excavation process, explaining each step clearly so you know exactly what to expect. Our expertise lies in aluminum wall pools paired with durable, heavy-duty beaded liners, ensuring both longevity and style. For equipment, we'll recommend the best filters and sanitation systems to deliver top-notch performance and hassle-free maintenance.
              </p>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-4">
                Once your pool is complete, we'll schedule a final walkthrough to familiarize you with your new pool equipment and demonstrate how to operate it. This session is also an opportunity to address any remaining questions, leaving you confident and ready to enjoy your pool.
              </p>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-6">
                At ATLAS PRO SERVICES LLC, our goal is to provide a smooth and stress-free experience, expertly guiding you from the first consultation to the final splash.
              </p>

              <Link
                to="/contact"
                className="inline-block bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-6 py-3 rounded-md text-sm transition-colors whitespace-nowrap"
              >
                Contact Us
              </Link>
            </div>

            {/* Right - Image */}
            <div>
              <img
                              src="/images/iStock-1172063305-2.jpg"
                alt="Metal frame swimming pool ready for a bath"
                className="w-full h-auto rounded-lg border border-gray-200"
                width={961}
                height={836}
              />
            </div>
          </div>
        </div>
      </section>

          {/* Brochure Section */}
          <section className="py-12 md:py-16 bg-gray-50">
              <div className="max-w-[1400px] mx-auto px-4 md:px-8 text-center">
                  <p className="text-sm md:text-base text-gray-700 mb-8">Check out the new Brochure below!</p>
              </div>
              <div className="max-w-[1400px] mx-auto px-4 md:px-8">
                  <FlipbookViewer
                      title="Vista Above Ground Pool Brochure"
                      downloadUrl="/images/vista-brochure-1.pdf"
          />
        </div>
      </section>
    </div>
  );
}